type Props = {
  onClick?: () => void;
  onToggle?: () => void;
  onDeletion: () => void;
  label: string;
  id?: string;
  negated?: boolean;
};

//  @function ProducerTrigger
//  Renders a self-updating trigger component used in cell logic compositon capable of switching its negation status
//  @param {function} onClick - function called everytime the trigger is clicked upon
//  @param {function} onToggle - function to be called everytime the trigger is inverted
//  @param {function} onDeletion - function to be called everytime the trigger is deleted
//  @param {string} label - string to be displayed in the trigger
//  @param {string} id - string used to recognize the component and its elements
//  @param {boolean} negated - initial trigger's negation status
//  @returns {React.Node}
export default function ProducerTrigger({
  onClick,
  onToggle,
  onDeletion,
  label,
  id,
  negated = false,
}: Props) {
  const colouring = {
    background: {
      delete: "#C4C4C4",
    },
    colour: "#FFFFFF",
  };

  const backgroundColor = negated ? "#DF1D1D" : "#9FC131";

  return (
    <div
      id={`${id}_root`}
      className="flex flex-row items-center bg-transparent w-fit p-1 relative m-1 z-10 "
      style={{
        color: colouring.colour,
        backgroundColor,
      }}
    >
      {negated && (
        <div className="absolute z-20 left-7 -top-3 text-black text-6xl">x</div>
      )}
      <div
        id={`${id}_deleter`}
        className="absolute top-[1rem]  -ml-3 self-end select-none cursor-pointer w-4 h-4 leading-4 text-center -mb-2 mr-1 z-0 rounded-full"
        style={{ backgroundColor: colouring.background.delete }}
        onClick={() => onDeletion()}
      >
        ×
      </div>

      <p
        id={`${id}_main`}
        className="select-none cursor-pointer px-4 leading-10 text-xl z-30"
        onClick={onClick}
      >
        {label}
      </p>

      <div className=" absolute z-0 mr-0 -right-2 ">
        <div
          id={`${id}_toggler`}
          className="cursor-pointer w-4 h-6  rounded-full "
          style={{
            backgroundColor,
          }}
          onClick={onToggle}
        ></div>
      </div>
    </div>
  );
}
